import { render, staticRenderFns } from "./MerchantBanners.vue?vue&type=template&id=31017379&scoped=true"
import script from "./MerchantBanners.vue?vue&type=script&lang=js"
export * from "./MerchantBanners.vue?vue&type=script&lang=js"
import style0 from "./MerchantBanners.vue?vue&type=style&index=0&id=31017379&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31017379",
  null
  
)

export default component.exports